/**
 * ZITELOU - StatCard
 * Carte de statistique pour le dashboard
 */

import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/solid';

const StatCard = ({
  title,
  value,
  change,
  changeType = 'positive', // positive, negative, neutral
  icon: Icon,
  iconBgColor = 'bg-blue-100',
  iconColor = 'text-blue-600',
  loading = false,
}) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-green-600';
    if (changeType === 'negative') return 'text-red-600';
    return 'text-gray-600';
  };

  const ChangeIcon = changeType === 'positive' ? ArrowUpIcon : changeType === 'negative' ? ArrowDownIcon : null;

  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-6 animate-pulse">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="h-4 bg-gray-200 rounded w-24 mb-3"></div>
            <div className="h-8 bg-gray-200 rounded w-32 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-20"></div>
          </div>
          <div className={`w-12 h-12 rounded-lg ${iconBgColor} opacity-50`}></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-lg transition-shadow duration-200">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          {/* Title */}
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>

          {/* Value */}
          <h3 className="text-3xl font-bold text-gray-900 mb-2">{value}</h3>

          {/* Change */}
          {change && (
            <div className="flex items-center gap-1">
              {ChangeIcon && <ChangeIcon className={`w-4 h-4 ${getChangeColor()}`} />}
              <span className={`text-sm font-medium ${getChangeColor()}`}>
                {change}
              </span>
              <span className="text-sm text-gray-500">ce mois</span>
            </div>
          )}
        </div>

        {/* Icon */}
        {Icon && (
          <div className={`w-12 h-12 rounded-lg ${iconBgColor} flex items-center justify-center`}>
            <Icon className={`w-6 h-6 ${iconColor}`} />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
